export default __webpack_public_path__ + "static/media/maintenance-mode.2da365c5.svg";